import APIIssueReports from '@console/components/project/APIIssueReports';
import type { AppState } from '@console/reducers';
import { getApiGiftCardIssueReports } from '@console/selectors/projectDetail/giftCardIssueCounts';
import { getApiGifteeBoxIssueReports } from '@console/selectors/projectDetail/gifteeBoxIssueCounts';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  giftCardIssueReports: getApiGiftCardIssueReports(state),
  gifteeBoxIssueReports: getApiGifteeBoxIssueReports(state),
  loading: state.loaders.isAPIIssueReportsLoading
});

const mapDispatchToProps = () => ({});

export type IssueReportsPropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;

export type IssueReportsPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(APIIssueReports);
